import {useDispatch, useSelector} from 'react-redux'
import {useState} from 'react'
import {Alert, Col, Form, Row, Modal, Button} from 'react-bootstrap'
import {
    getNote,
    isBusiness,
    isEPQCodeSuccessful, useDataState,
    useInputDataState,
    useIsMexico,
    useIsPR,
    useLabels
} from '../../functions'
import {FormCheck, FormLabel} from '../Utilities/Form'
import {OptionalServices} from './OptionalServices'
import {connect} from '../Notes/wrapper'
import {
    changePriorityPackage,
    getFlexOfferAvailability,
    getPlansVisualPage,
    writeToRedis
} from '../../state/customerAsyncActions'
import {openAlert, setDataState} from '../../state/customerSlice'
import {BroadbandFacts} from './BroadbandFacts'
import {setAppLoadingState} from '../../state/settingsSlice'
import './plan.scss'

export const Plans = () => {
    const state = useSelector(state => ({
        settings: {
            successfulPimCodes: state.settings.successfulPimCodes
        }, customer: {
            data: {
                epqPim: state.customer.data.epqPim
            }
        }
    }))
    const plans = useSelector(state => state.customer.plans)
    const labels = useLabels()
    const [plan, setPlan] = useInputDataState('plan')
    const epqPass = useSelector(state => state.customer.data.epqPass)
    const lease = useSelector(state => state.customer.data.lease)
    const recommendedPlan = useSelector(state => state.customer.data.recommendedPlan)
    const agreeToCreditCheck = useSelector(state => state.customer.data.agreeToCreditCheck)
    const showCreditCheck = useSelector(state => state.customer.data.showCreditCheck)
    const agentNotes = useSelector(state => state.settings.notes)
    const showPaymentOptions = useSelector(state => state.customer.data.showPaymentOptions)
    const dispatch = useDispatch()
    const isPR1 = useIsPR()
    const isMexico = useIsMexico()
    const continuity = useSelector(state => state.customer.data.continuity)
    const script = useSelector(state => state.customer.data.script)
    const customerEligibleDishBundle = useSelector(state => state.customer.data.dish_subscriber_verified)
    const [dishBundleAccepted, setDishBundleAccepted] = useInputDataState('dishBundleAccepted')
    const [, setMeshSelection] = useDataState('meshSelection')
    const [, setVoipSelection] = useDataState('voipSelection')
    const [planPopover, setPlanPopover] = useState('')
    const planAgentNotes = useSelector(state => state.customer.data.planAgentNotes)

    const hookSetPlan = async (e) => {
        setPlan(e)
        await dispatch(getFlexOfferAvailability())
        if (!isMexico) {
            dispatch(openAlert(labels.confirmPlanSelected?.replace('{plan}', e.target.value)))
        }
        if (e.target.value === 'Lite') {
            setMeshSelection('')
            setVoipSelection('')
        }
    }

    let plansComponent

    function isLeaseNotAllowed() {
        return !showPaymentOptions || !showCreditCheck || (showPaymentOptions && showCreditCheck && !agreeToCreditCheck)
    }

    const setLease = (e) => {
        dispatch(setDataState({key: 'lease', value: e.target.value}))
        dispatch(setDataState({key: 'paymentOption', value: e.target.value === 'Y' ? 'L' : 'U'}))
    }

    if (isEPQCodeSuccessful(state) && Array.isArray(plans) && plans.length > 0) {
        let offerComponent
        const note = getNote(agentNotes, 'plan-and-optional-services-offer')
        if (note) {
            offerComponent = <Row>
                <Col>
                    <div dangerouslySetInnerHTML={{__html: note.text}}/>
                </Col>
            </Row>
        }

        const handleDishBundle = async (e) => {
            dispatch(setAppLoadingState('pending'))
            setDishBundleAccepted(e)
            dispatch(writeToRedis())
            await dispatch(changePriorityPackage())
            await dispatch(getPlansVisualPage())
            dispatch(setAppLoadingState(''))
        }

        plansComponent = <>
            {offerComponent}
            <Row>
                <Col>
                    <Alert>
                        <h3>{labels.planSectionHeader}</h3>
                        <h5>{labels.planSectionHeaderHelp}</h5>
                    </Alert>
                </Col>
            </Row>
            <Row className="mb-3 plans-list">
                <Col>
                    <Form.Group>
                        <FormLabel bold={true}>{labels.pickServicePlan}</FormLabel>
                        {plans.map(p => {
                                const label = <>
                                    {p} {p === recommendedPlan ?
                                    <span className="recommended">RECOMMENDED</span> : null}
                                </>
                                return <>
                                    <FormCheck key={p} disabled={!isMexico && epqPass !== '2' && lease === 'Y'}
                                               type="radio"
                                               name="plan" value={p} label={label} checked={plan === p}
                                               onChange={hookSetPlan}>
                                        {planAgentNotes ?
                                            <svg onClick={() => setPlanPopover(p)} viewBox="0 0 576 512"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"/>
                                            </svg> : null
                                        }
                                    </FormCheck>
                                </>
                            }
                        )}
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.Group>
                        <FormLabel bold={true}>{labels.equipmentOption}</FormLabel>
                        <FormCheck disabled={isLeaseNotAllowed()} label={labels.leaseOption} value="Y"
                                   checked={lease === 'Y'}
                                   name="lease" onChange={setLease}/>
                        {!isMexico ?
                            <FormCheck label={labels.purchaseOption} value="N" checked={lease === 'N'} name="lease"
                                       onChange={setLease}/> : null}
                    </Form.Group>
                </Col>
            </Row>
            {!isMexico && !isPR1 && customerEligibleDishBundle && continuity !== 'Continuity' ? <Row className="mb-3">
                <Col>
                    <FormLabel bold={true}>{labels.dishBundleAccepted}</FormLabel>
                    <FormCheck type="radio" label={labels.yesOption} value="Yes" onChange={handleDishBundle}
                               checked={dishBundleAccepted === 'Yes'}/>
                    <FormCheck type="radio" label="No" value="No" onChange={handleDishBundle}
                               checked={dishBundleAccepted === 'No'}/>
                </Col>
            </Row> : null}
            {!isMexico && !isBusiness(script) ? <BroadbandFacts/> : null}
        </>
    }
    return <>
        {plansComponent}
        {!isMexico ? <OptionalServices/> : null}
        <Modal
            show={planPopover !== ''}
            size="lg"
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    <h3>{planPopover}</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div dangerouslySetInnerHTML={{__html: planAgentNotes ? planAgentNotes[planPopover] : null}}></div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setPlanPopover('')}>Close</Button>
            </Modal.Footer>
        </Modal>
    </>
}

export default connect(Plans, 'plans')
